module.exports = __webpack_public_path__ + "static/media/pharmhaus.4e3e864d.jpg";